import React from 'react';
import { Col, Container, Form, Row } from 'react-bootstrap';
import chevronSVG from '../../assets/images/chevron.svg';
import Deleteround from '../Common/Button/Deleteround';
import Pencilround from '../Common/Button/Pencilround';
import CustomSelect from '../Common/Select/CustomSelect';
export default function PreviousInventory() {
  return (
    <>
      <Container className="general-title">
        <h1>Previous Inventory</h1>
        <label>Add, Manage and Edit Previous Inventoriess</label>
      </Container>
      <Container className="white-container py-5 mb-5">
        <div className="   position-relative">
          <Row className="px-4 pb-3 justify-content-between">
            <Col lg={4} md={12}>
              <input
                className="searchInput"
                type="search"
                placeholder="Search"
              />
            </Col>
            <Col lg={3} md={12}>
              <Form className="">
                <Form.Group className="d-flex " controlId="formBasicRecords">
                  <Form.Label className="subTitle w-100 align-self-center text-end pe-2 pt-2">
                    Records Per Page
                  </Form.Label>
                  <CustomSelect />
                </Form.Group>
              </Form>
            </Col>
          </Row>
        </div>
        <Row className=" px-lg-2 py-2 justify-content-evenly align-items-center">
          <Col className="tableTitle   pe-0 " lg={1}>
            ITEM NAME
            <img className="ps-2" src={chevronSVG} alt="chevron" />{' '}
          </Col>
          <Col className="tableTitle pe-0" lg={1}>
            ITEM IMAGE <img className="ps-2" src={chevronSVG} alt="chevron" />
          </Col>
          <Col className="tableTitle  pe-0" lg={1}>
            SKU CODE <img className="ps-2" src={chevronSVG} alt="chevron" />
          </Col>
          <Col className="tableTitle" lg={1}>
            UPC <img className="ps-2" src={chevronSVG} alt="chevron" />
          </Col>
          <Col className="tableTitle" lg={2}>
            MANUFACTURER'S CODE{' '}
            <img className="ps-2" src={chevronSVG} alt="chevron" />
          </Col>
          <Col className="tableTitle ps-0 pe-0" lg={1}>
            RETAIL PRICE <img className="ps-2" src={chevronSVG} alt="chevron" />
          </Col>
          <Col className="tableTitle pe-0" lg={1}>
            DESIGNER <img className="ps-2" src={chevronSVG} alt="chevron" />
          </Col>
          <Col className="tableTitle ps-0 pe-0" lg={1}>
            Date of Sale <img className="ps-2" src={chevronSVG} alt="chevron" />
          </Col>
          <Col className="tableTitle" lg={2}>
            PURCHASE DATE{' '}
            <img className="ps-2" src={chevronSVG} alt="chevron" />
          </Col>
          <Col className="tableTitle" lg={1}>
            ACTIONS
          </Col>
        </Row>
        <Row className=" px-lg-2 py-1 tableContentBg mb-2 justify-content-evenly align-items-center">
          <Col className="itemName pe-0 " lg={1}>
            TIARA OFF RACK
          </Col>
          <Col className="content-midsize  pe-0" lg={1}>
            -
          </Col>
          <Col className="content-midsize  pe-0" lg={1}>
            -
          </Col>
          <Col className="content-midsize " lg={1}>
            -
          </Col>
          <Col className="content-midsize" lg={2}>
            Tiara
          </Col>
          <Col className="content-midsize ps-0 pe-0" lg={1}>
            954
          </Col>
          <Col className="content-midsize" lg={1}>
            Bling
          </Col>
          <Col className="tableContent ps-0 pe-0" lg={1}>
            02/07/2021 AT 1:00PM
          </Col>
          <Col className="tableContent" lg={2}>
            02/07/2021 AT 1:00PM
          </Col>
          <Col className="tableContent d-flex" lg={1}>
            <div className="pe-2">
              <Pencilround />
            </div>

            <div>
              <Deleteround />
            </div>
          </Col>
        </Row>
        <Row className=" px-lg-2 py-1 tableContentBg mb-2 justify-content-evenly align-items-center">
          <Col className="itemName  pe-0 " lg={1}>
            TIARA OFF RACK
          </Col>
          <Col className="content-midsize  pe-0" lg={1}>
            -
          </Col>
          <Col className="content-midsize pe-0" lg={1}>
            -
          </Col>
          <Col className="content-midsize " lg={1}>
            -
          </Col>
          <Col className="content-midsize" lg={2}>
            Tiara
          </Col>
          <Col className="content-midsize ps-0 pe-0" lg={1}>
            954
          </Col>
          <Col className="content-midsize" lg={1}>
            Bling
          </Col>
          <Col className="tableContent ps-0 pe-0" lg={1}>
            02/07/2021 AT 1:00PM
          </Col>
          <Col className="tableContent" lg={2}>
            02/07/2021 AT 1:00PM
          </Col>
          <Col className="tableContent d-flex" lg={1}>
            <div className="pe-2">
              <Pencilround />
            </div>

            <div>
              <Deleteround />
            </div>
          </Col>
        </Row>
        <Row className=" px-lg-2 py-1 tableContentBg mb-2 justify-content-evenly align-items-center">
          <Col className="itemName  pe-0 " lg={1}>
            TIARA OFF RACK
          </Col>
          <Col className="content-midsize  pe-0" lg={1}>
            -
          </Col>
          <Col className="content-midsize  pe-0" lg={1}>
            -
          </Col>
          <Col className="content-midsize " lg={1}>
            -
          </Col>
          <Col className="content-midsize" lg={2}>
            Tiara
          </Col>
          <Col className="content-midsize ps-0 pe-0" lg={1}>
            954
          </Col>
          <Col className="content-midsize" lg={1}>
            Bling
          </Col>
          <Col className="tableContent ps-0 pe-0" lg={1}>
            02/07/2021 AT 1:00PM
          </Col>
          <Col className="tableContent" lg={2}>
            02/07/2021 AT 1:00PM
          </Col>
          <Col className="tableContent d-flex" lg={1}>
            <div className="pe-2">
              <Pencilround />
            </div>

            <div>
              <Deleteround />
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}
